<script lang="ts" setup>
import { message } from 'ant-design-vue'
import { getSecretNumber } from '~/server/newhouse'
import { secretNumberTrackingSave } from '~/server/common'
import { formatPhoneNumber } from '~/utils/utils-js'

interface dataType {
  floorId: number
  cityId: number
}
const props = defineProps({
  floorInfo: {
    type: Object as () => dataType,
    default: () => ({}),
  },
  advisorInfo: {
    type: Object,
    default: () => (null),
  },
  configId: {
    type: String,
    default: '',
  },
})

const LazyWxQrImage = defineAsyncComponent(() => import('@/components/WechatDial/WxQrImage.vue'))
// 隐私号电话
const privacyNumber = ref<string>('')
// 隐私号提示
const privacyErrTip = ref<string>('')
// 获取隐私号
const userStore = useUserInfoStore()
const nuxtApp = useNuxtApp()
const uuid = ref('')
const route = useRoute()

/**
 * setSecretFloorPhone： 存储隐私号到cookie，并设置10分钟的有效时间。此方法在获取隐私号成功后调用
 * getSecretFloorPhone： 获取隐私号，返回{  phone, countdown }，phone为隐私号,countdown为倒计时剩余秒数，在页面打开的时候调用
 * countDown： 给定一个倒计时函数，在倒计时结束后调用，在需要自定义执行函数的时候调用，这里的 两处 我需要在倒计时结束后清空隐私号
 */
const { setSecretFloorPhone, getSecretFloorPhone, countDown } = useCommon()
getSecretFloorPhone(props.floorInfo?.floorId).then((res: any) => {
  if (res) {
    const { phone, countdown } = res
    privacyNumber.value = phone
    countDown(() => {
      privacyNumber.value = ''
      privacyErrTip.value = ''
    }, countdown)
  }
})

function handlePrivacyNumber() {
  if (privacyNumber.value || privacyErrTip.value)
    return
  getSecretNumber({ floorId: props.floorInfo.floorId, cityId: props.floorInfo.cityId, type: 1 }).then((res) => {
    const { code, dataBody, message: msg } = res
    if (code === 0) {
      if (!dataBody) {
        message.warning('当前线路忙，请稍后再拨')
        return
      }
      const { phoneX, obtainResult } = res.dataBody

      /**
       * setSecretFloorPhone缓存十分钟，并且开启倒计时
       * 十分钟后隐私号时效，清空隐私号countDown
       */
      setSecretFloorPhone(props.floorInfo?.floorId, phoneX)
      countDown(() => {
        privacyNumber.value = ''
        privacyErrTip.value = ''
      })

      privacyNumber.value = phoneX
      // 埋点统计
      const { userId } = userStore?.userInfo ?? {}
      uuid.value = nuxtApp.$getUuid()
      const { params } = route
      const { floorId, houseModelId, floorHouseId } = params
      // 隐私号埋点统计
      secretNumberTrackingSave({
        businessDataId: 1,
        businessId: props.floorInfo.floorId,
        cityId: props.floorInfo.cityId,
        equipmentBrowseUuid: uuid.value,
        numberId: floorHouseId || houseModelId || floorId || props.floorInfo.floorId,
        obtainResult,
        pageName: document.title,
        pageUrl: `${window.location.origin}${route.fullPath}`,
        portTypeId: 1,
        sectionId: 1,
        userId: userId || 0,
      })
    }
    else if ([1407001, 1407002, 1407003].includes(code)) {
      privacyErrTip.value = msg
    }
    else { message.warning(msg) }
  })
}

const configMap = inject<any>('configMap')
const injectFloorInfo = inject<any>('floorInfo')

const { commonCollect } = userInfoAction()
// 咨询置业顾问
async function handleCollect(adviserId: number) {
  const config = configMap.value?.[props.configId] || {}
  await commonCollect({
    configId: config?.configId,
    cityId: injectFloorInfo.value?.cityId,
    floorId: injectFloorInfo.value.floorId,
    source: '新房/PC/楼盘首页',
    sourceTypeId: 1,
    adviserId,
    message: '我刚浏览了这个楼盘，请问可以介绍下吗？',
  })
}
</script>

<template>
  <div class="phone">
    <div class="qr-code">
      <ClientOnly>
        <LazyWxQrImage v-bind="floorInfo" />
      </ClientOnly>
    </div>
    <!--    <i v-show="!privacyErrTip" class="iconfont icon-tel" /> -->
    <div class="text" @click="handlePrivacyNumber">
      <div class="show-phone">
        {{ privacyErrTip || formatPhoneNumber(privacyNumber) || '点击查看电话' }}
      </div>
      <div v-show="!privacyErrTip" class="scan-code">
        {{ privacyNumber ? '请尽快拨打，如拨打失效请刷新' : '扫码致电售楼处，了解更多优惠' }}
      </div>
    </div>
    <div v-show="advisorInfo" class="advisor">
      <div class="avatar">
        <img :src="advisorInfo?.headPic" alt="头像">
      </div>
      <div class="info">
        <div class="name">
          {{ advisorInfo?.trueName }} <img src="@/assets/images/gold-advisor.png" class="gold-advisor" alt="">
        </div>
        <div class="online cursor-pointer" @click="handleCollect(advisorInfo.adviserId)">
          <img src="@/assets/images/online.png" style="image-rendering: pixelated;" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$qr-radius: 50px;
.phone {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: $qr-radius *2;
  padding-left: 130px;
  background: #F5F5F6;
  border-radius: 10px;
  overflow: hidden;
  .iconfont {
    color: #fff;
    padding: 13px;
    font-size: 35px;
    background-color: $c1;
    border-radius: 50%;
  }
}

.text {
  //margin-left: 10px;
  cursor: pointer;

  .show-phone {
    font-family: Alibaba PuHuiTi 3.0;
    font-size: 25px;
    font-weight: bold;
    color: #3D3D3D;
    line-height: 30px;
    margin-bottom: 10px;
  }

  .scan-code {
    font-size: 12px;
    color: #9C9C9C;
  }
}

.qr-code {
  position: absolute;
  border-radius: 50%;
  left: -58px;
  width: $qr-radius * 3.5;
  height: $qr-radius * 3.5;

  overflow: hidden;
  background-color: #ffffff;
  //padding: 37px 0 0 25px;

  .qr-code-img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-29%, -50%);
  }

  img {
    width: 100%;
    height: 100%;
  }
}

.advisor {
  display: flex;
  align-items: center;
  padding: 10px 0;
  margin-left: auto;
  margin-right: 10px;

  .avatar {
    width: 55px;
    height: 55px;
    border-radius: 50%;
    overflow: hidden;
    position: relative;

    img {
      //width: 100%;
      //position: absolute;
      //top: 50%;
      //left: 50%;
      //transform: translate(-50%, -50%);
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .info {
    margin-left: 8px;
    line-height: 30px;

    .name {
      font-size: 16px;
      color: #3D3D3D;
      display: flex;
      @include ell();

      .gold-advisor {
        height: 22px;
        margin-left: 5px;
      }
    }
    .online {
      //margin-top: 2px;
      //width: 105px;

      img {
        //width: 100%;
        width: 105px;
      }
    }
  }
}
</style>
